module.exports = __webpack_public_path__ + "img/persistence-light.5387dc19.svg";